// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608050409/js/" + chunkId + "." + {"44":"05e26896","225":"04d8b7f8","481":"92574679","486":"3b343e17","770":"934eed4f"}[chunkId] + ".0.6525717258356575.chunk.js";
};